import React, { useState } from "react";
import { ReactComponent as CaloriesIcon } from "../../../../../assects/svg/client_details/calories.svg";
import { ReactComponent as ArrowUpRight } from "../../../../../assects/svg/client_details/ArrowUpRight.svg";
import Drawer from "./Drawer";
import { Exercise } from "../../../hooks/useAllLogsData";

interface ExerciseCardProps {
  exercises: Exercise[];
  selectedDate?: string;
}

const ExerciseCard: React.FC<ExerciseCardProps> = ({ exercises, selectedDate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const formatTime = (timeStr: string): string => {
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "pm" : "am";
    const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
    return `${displayHour.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  };

  const formatDuration = (minutes: number): string => {
    if (minutes < 60) return `${minutes}mins`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (remainingMinutes === 0) return `${hours}hr`;
    return `${hours}hr ${remainingMinutes}mins`;
  };

  const renderExerciseEntry = (exercise: Exercise) => (
    <div>
      <div className="flex items-center justify-between">
        <p className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F]">
          {exercise.exercise_name}
        </p>
        <div className="flex gap-1">
          <CaloriesIcon className="w-4 h-4 flex-shrink-0" />
          <span className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F] flex-shrink-0">
            {exercise.total_calories}kcal
          </span>
        </div>
      </div>

      {/* =======================================================================
          OLD: used exercise.duration_minutes
          NEW: uses exercise.duration_in_minutes
          ======================================================================= */}
      {/* OLD — comment this line + uncomment NEW line to switch */}
      <div className="flex items-center gap-1 text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
  <span className="flex-shrink-0">
    {formatTime(exercise.starting_time)} | {formatDuration(exercise.duration_minutes)}
  </span>
  {exercise.comment && (
    <>
      <span className="flex-shrink-0">|</span>
      <span
        className="truncate"
        title={exercise.comment}
      >
        {exercise.comment}
      </span>
    </>
  )}
</div>

      {/* NEW — comment this line + uncomment OLD line to revert */}
      {/* <p className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
        {formatTime(exercise.starting_time)} | {formatDuration(exercise.duration_in_minutes)}
        {exercise.comment && ` | ${exercise.comment}`}
      </p> */}
      {/* ======================================================================= */}
    </div>
  );

  const displayedExercises = exercises.slice(0, 2);

  if (!exercises || exercises.length === 0) {
    return (
      <div className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full">
        <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase mb-4">
          EXERCISE
        </h3>
        <div className="flex-1 flex items-center justify-center pb-4">
          <p className="text-sm font-medium text-[#646464] font-inter">No entries yet</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div onClick={() => setIsDrawerOpen(true)} className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full cursor-pointer">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase">
            EXERCISE
          </h3>
          <button
            
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="View all exercises"
          >
            <ArrowUpRight className="w-4 h-4 3xl:w-5 3xl:h-5 text-[#1F1F1F]" />
          </button>
        </div>

        <div>
          {displayedExercises.map((exercise, index) => (
            <React.Fragment key={index}>
              {renderExerciseEntry(exercise)}
              {index < displayedExercises.length - 1 && (
                <div className="w-full border-t border-gray-200 my-2.5"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Exercise"
        selectedDate={selectedDate}
      >
        <div className="space-y-3">
          {exercises.map((exercise, index) => (
            <div key={index} className="pb-3 border-b border-gray-100">
              {renderExerciseEntry(exercise)}
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default ExerciseCard;